import type { TFunction } from "i18next";
import type { StructuredOutput } from "../../../api/threads/liveMessages";

/**
 * A step's result at a glance, in the Run view's words: how many statements or annotations it holds, else what kind
 * it is ("3 Aussagen", "Änderungssatz"). Where the current step shows the result, the log names it so (hill climb
 * round 1, C2).
 */
export function resultGlance(output: StructuredOutput, t: TFunction): string {
  switch (output.output_kind) {
    case "instance_data":
      return t("threads.runGraph.count.instance_data", { count: output.statements.length });
    case "annotations":
      return t("threads.runGraph.count.annotations", { count: output.annotations.length });
    case "change_set":
      return t("threads.toolTurn.valueKinds.change_set");
    case "value":
      return t(`threads.toolTurn.valueKinds.${output.value_kind}`);
  }
}
